import React from 'react';
import styled from 'styled-components';

import PresetButton from '../../../PresetButton';

import type { INightsPreset } from './types';

export const NightsPreset = (props: INightsPreset): JSX.Element => {
  const { title, icon: Icon, isSelected, handleClick, isMobile } = props;

  return (
    <PresetButton isSelected={isSelected} handleClick={handleClick} isMobile={isMobile}>
      <div>
        <Icon />
        <StyledDurationButtonText>{title}</StyledDurationButtonText>
      </div>
    </PresetButton>
  );
};

const StyledDurationButtonText = styled.div`
  width: 90px;
  margin-top: 2px;
`;
